module.exports = __webpack_public_path__ + "img/ic-search.0830fa5f.svg";